import React from 'react';
import { keyboard_screen_example } from '../utils/DictionaryManagementUtils';
import ConfirmTransferFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Confirmation/ConfirmTransferFP';
import EnableKeyboardFP from '../components/SimulatorsComponents/FullPagesComponents/OnBoarding/EnableKeyboardFP';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';

//= ========================================================================
const Sim_X02_themeFonts = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => {
  const subCategoryId = 'send_money_0';
  const { confirmation } = globJSON.configurations.services[subCategoryId];
  return (
    <SimulatorsViewerArrangement>
      <EnableKeyboardFP
        globJSON={globJSON}
        language={language}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
      <ConfirmTransferFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        confirmation={confirmation}
        subCategoryId={subCategoryId}
        headlineText={confirmation.does_it_look_ok}
        withoutIconLine
        TopTitle={keyboard_screen_example}
        slideshowRefs={slideshowRefs}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Sim_X02_themeFonts;
